<template>
  <div class="col-xs-12 col-sm-6 timeinfo-list-sty">
    <div class="" v-if="parentType !== 'order'">
      <div class="order-title-area-sty">
        <div class="order-main-title-sty">
          <h3>訂單 # {{ orderId }}</h3>
        </div>
      </div>
      <hr>
      <div class="order-contain">
        <div class="order-sub-title-sty">
          <h5>服務時間詳情</h5>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-12 order-info-label-sty">總時數</div>
          <div class="col-sm-12">{{ totalTime }}</div>
        </div>
        <div class="row order-info-group-sty">
          <div class="col-sm-12 order-info-label-sty">服務時段</div>
          <div class="col-sm-12" v-for="(cleanTime, index) in cleanTimeLabels" :key="index">
            <span>{{ cleanTime }}</span>
          </div>
        </div>
        <hr>
        <div class="order-footer-contain text-left">
          <!-- <b-button
            class="text-white order-info-btn-sty"
            variant="primary"
            size="md"
            @click="conFirm">
            確認
          </b-button> -->
        </div>
      </div>
    </div>
    <div class="" v-else>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TimeInfo',
  props: {
    userId: String,
    category: String,
    orderId: String,
    parentType: String
  },
  created () {
    this.$nextTick(() => {
      this.getTimeInfo()
    })
  },
  data () {
    return {
      totalTime: '',
      cleanTimeLabels: []
    }
  },
  methods: {
    getTimeInfo () {
      const self = this
      var baseUrl = this.category === 'customer' ? this.$apiDoc.customerUrl : this.$apiDoc.staffUrl
      var getUrl = baseUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiGetTimeInfo
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$api.get(getUrl).then((resp) => {
        if (resp.result && resp.data) {
          self.totalTime = resp.data.total_timing
          self.cleanTimeLabels = resp.data.clean_time_labels
        }
      }).catch((errorInfo) => {
        var errorResp
        if (errorInfo.response) {
          errorResp = errorInfo.response
          if (errorResp.data) {
            errorMsg = self.$toolDoc.convertErrorMsg(errorResp.data)
          }
        }
        alert(errorMsg)
      })
    }
    // conFirm () {
    // }
  }
}
</script>
